import type { CuratedCopy } from "./preview-copy.types";
export const webdiplomacyCopy: CuratedCopy = {
  blurb:
    "Classic Diplomacy on the real webDiplomacy server. Seven powers write orders in secret, all at once, and the only way to reach 18 of the 34 supply centers is to make alliances and know when to break them.",
  beats: () => [
    {
      title: "Orders resolve together",
      body: "Every power orders at once: move, hold, support or convoy. Equal attacks bounce and support can be cut.",
    },
    {
      title: "Press or gunboat",
      body: "Play with negotiation between powers, or the no-talking gunboat league.",
    },
    {
      title: "Win the map",
      body: "Supply-center ownership decides builds and removals each winter. Control 18 of 34 to win outright.",
    },
  ],
};
